module.exports = __webpack_public_path__ + "static/img/en.f3cd2914.svg";